<div class="card flex justify-content-center">
  <p-card [header]="pageTitle"
          [style]="{ width: '360px' }"
          class="flex justify-content-center">

    <form [formGroup]="editClientForm">
      <div>
        <label for="name"
               class="block text-900 font-medium mb-2">Client Name</label>
        <input id="name"
               formControlName="name"
               required
               type="text"
               placeholder="Client Name"
               class="p-inputtext p-component p-element w-full mb-3">
               <label for="isActive"
               class="block text-900 font-medium mb-2"> Is Active</label>
        <p-inputSwitch formControlName="isActive"></p-inputSwitch>


        <label for="serviceTypeItem"
               class="block text-900 font-medium mb-2"> Service Type</label>
        <p-dropdown class="block text-900 font-medium mb-2"
                    formControlName="serviceTypeItem"
                    [options]="clientServiceTypePDropdownItems"
                    optionLabel="value"
                    placeholder="Select Service Type"></p-dropdown>

        <label for="subscriptionTypeItem"
        class="block text-900 font-medium mb-2"> Service Type</label>
 <p-dropdown class="block text-900 font-medium mb-2"
             formControlName="subscriptionTypeItem"
             [options]="subscriptionTypePDropdownItems"
             optionLabel="value"
             placeholder="Select SubScription Type"></p-dropdown>

        <label for="subscriptionLengthTypeItem"
        class="block text-900 font-medium mb-2"> Service Type</label>
 <p-dropdown class="block text-900 font-medium mb-2"
             formControlName="subscriptionLengthTypeItem"
             [options]="subscriptionLengthTypePDropdownItems"
             optionLabel="value"
             placeholder="Select SubScription Length"></p-dropdown>

             <label for="subscriptionStartDate"
        class="block text-900 font-medium mb-2"> Start Date</label>
        <p-calendar class="block text-900 font-medium mb-2"
        [minDate]="minDate"
        [maxDate]="maxDate"
        required
        formControlName="subscriptionStartDate"
        [showIcon]="true"></p-calendar>

        <label for="subscriptionEndDate"
        class="block text-900 font-medium mb-2"> End Date</label>
        <p-calendar class="block text-900 font-medium mb-2"
        [minDate]="minDate"
        [maxDate]="maxDate"
        required
        formControlName="subscriptionEndDate"
        [showIcon]="true"></p-calendar>

        <label for="path"
               class="block text-900 font-medium mb-2">Enter Path</label>
        <input id="path"
               formControlName="path"
               required
               type="text"
               placeholder="Enter Path"
               class="p-inputtext p-component p-element w-full mb-3">

        <div class="flex">
          <label for="reportHeaderColor"
                 class="block text-900 font-medium mb-2">Report Header Color</label>

          <p-colorPicker formControlName="reportHeaderColor"
                         class=" ml-3"></p-colorPicker>
        </div>
        <label for="contactName"
               class="block text-900 font-medium mb-2">Contact Name</label>
        <input id="contactName"
               formControlName="contactName"
               required
               type="text"
               placeholder="Contact Name"
               class="p-inputtext p-component p-element w-full mb-3">

        <label for="phone"
               class="block text-900 font-medium mb-2">Phone</label>
        <p-inputMask mask="(999) 999-9999"
                     formControlName="phone"
                     placeholder="Enter ph"
                     required
                     placeholder="(999) 999-9999"
                     class="p-component p-element w-full mb-3"></p-inputMask>

        <label for="email"
               class="block text-900 font-medium mb-2">Email</label>
        <input id="email1"
               formControlName="email"
               required
               type="email"
               placeholder="Enter Your email"
               class="p-inputtext p-component p-element w-full mb-3">

        <label for="address"
               class="block text-900 font-medium mb-2">Address</label>
        <input id="address"
               formControlName="address"
               required
               type="text"
               placeholder="Address"
               class="p-inputtext p-component p-element w-full mb-3">

        <label for="city"
               class="block text-900 font-medium mb-2">City</label>
        <input id="city"
               formControlName="city"
               required
               type="text"
               placeholder="City"
               class="p-inputtext p-component p-element w-full mb-3">

        <p-dropdown [options]="stateOptions"
                    formControlName="stateItem"
                    optionLabel="name"
                    [filter]="true"
                    filterBy="name"
                    [showClear]="true"
                    placeholder="Select a State">
          <ng-template pTemplate="selectedItem"
                       let-selectedOption>
            <div class="flex align-items-center gap-2">
              <div>{{ selectedOption.code }}</div>
            </div>
          </ng-template>
          <ng-template let-state
                       pTemplate="item">
            <div class="flex align-items-center gap-2">
              <div>{{ state.name }}</div>
            </div>
          </ng-template>
        </p-dropdown>

        <!-- <label for="state"
               class="block text-900 font-medium mb-2">State</label>
        <input id="state"
               formControlName="state"
               required
               type="text"
               placeholder="State"
               class="p-inputtext p-component p-element w-full mb-3"> -->

        <label for="zip"
               class="block text-900 font-medium">Zip Code
        <input id="zip"
               formControlName="zip"
               required
               type="text"
               placeholder="zip"
               class="p-inputtext p-component p-element w-full my-2">
              </label>



      </div>
    </form>

    <ng-template pTemplate="footer">
      <div class="flex justify-content-between">
        <p-button class="btn btn-primary"
                  (click)="onSaveClient()"
                  [disabled]="!editClientForm.valid">Save</p-button>
        <p-button class="btn btn-primary"
                  (click)="onCancelClient()">Cancel</p-button>
      </div>
    </ng-template>
  </p-card>
</div>
